import { useSelector, useDispatch } from 'react-redux';
import { fetchLanguages } from '../../../redux/resources/resourcesSlice';
import { useCallback } from 'react';
import { RootState } from '../../../redux';
import { AppDispatch } from '../../../redux';

const useLanguagesResource = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { languages, isLoading } = useSelector((state: RootState) => state.resources);

    const fetchLanguagesData = useCallback(async () => {
        await dispatch(fetchLanguages());
    }, [dispatch]);

    return { languages, isLoading, fetchLanguages: fetchLanguagesData };
};

export default useLanguagesResource; 
